import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/web/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["StickyVideo"] */ "/home/runner/work/web/web/src/app/(frontend)/[locale]/ar-xr/StickyVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisionCarousel"] */ "/home/runner/work/web/web/src/app/(frontend)/[locale]/ar-xr/VisionCarousel.tsx");
